<template>
  <div :class="$style.wrapper">
    <v-help button="НАЧАТЬ" ref="startHelp" @click="stage = 1">
      Перед тобой смартфон Скобца. У некоторых приложений сейчас есть доступ к функциям смартфона, который им не нужен для полноценной работы. Зайди в приложение и отмени ненужные для него доступы.
    </v-help>
    <v-help button="НАЧАТЬ" ref="infoBox">
      <div :class="$style.infoBoxHeader">
        <div :class="$style.infoBoxImage" :style="{ backgroundImage: `url(${currentApp!==null ? apps[currentApp].image : ''})` }"></div>
        <span :class="$style.infoBoxTitle">{{currentApp!==null ? apps[currentApp].title : ''}}</span>
      </div>
      <br>
      {{currentApp!==null ? apps[currentApp].description : ''}}
    </v-help>
    <v-help button="OK" ref="errorBox">
      Без <b>{{ errorAccessId!==null ? accesses[errorAccessId].warning.toLowerCase() : '' }}</b> приложение не сможет работать.
    </v-help>
    <v-help button="OK" ref="promptBox">
      Для этого приложения лучше ограничить доступ к <b>{{ promptAccessId!==null ? accesses[promptAccessId].prompt.toLowerCase() : ''}}</b>.
    </v-help>
    <v-help button="Далее" ref="successBox" @click="$emit('success')">
      Теперь приложения не смогут получить доступ к личной информации. <br><br>
      Помни, в реальности нужные разрешения зависят от конкретного приложения.
    </v-help>

    <transition name="bounce">
      <h2 v-if="stage === 0">
        <vue-hacker-text text="Отмени лишний доступ приложений" speed="fast" :probability="0.7"/>
        <vue-hacker-text text="к функциям смартфона." speed="fast" :probability="0.7"/>
      </h2>
    </transition>
    <transition name="bounce">
      <h2 v-if="stage === 2">
        <vue-hacker-text text="Молодец! Ты помог Скобцу" :probability="0.9"/>
        <vue-hacker-text text="настроить нужные доступы." :probability="0.9"/>
      </h2>
    </transition>
    <transition name="fade">
      <div v-if="stage === 1" :class="$style.count">{{ plural(successCount, 'Настроено', 'Настроено', 'Настроено') }} {{ successCount }} / {{ apps.length }} приложений</div>
    </transition>

    <phone :data="apps"
           :accesses="accesses"
           :moveDown="stage === 0 || stage === 2"
           :disable="stage === 0 || stage === 2"
           @change="changeAccess"
           @checkAllApplications="checkAllApplications"
           @showInfoBox="showInfoBox"/>
  </div>
</template>
<script>
import phone from './components/phone/phone'

import data from './data'
import accesses from './accesses'
import plural from '@/utils/plural'

export default {
  name: 'trainer3',
  components: { phone },
  data() {
    return {
      data,
      accesses,
      plural,
      stage: 0,
      firstText: '',
      secondText: '',
      apps: [],
      currentApp: null,
      errorAccessId: null,
      promptAccessId: null,
      successCount: 0,
    }
  },
  methods: {
    isArrayEquals(a, b) {
      return Array.isArray(a)
      && Array.isArray(b)
      && a.length === b.length
      && a.every((val, index) => val === b[index])
    },
    checkAllApplications() {
      this.$refs.errorBox.close()
      this.$refs.promptBox.close()
      this.$refs.infoBox.close()
      let success = true
      this.apps.forEach((app) => {
        if (!app.success) success = false
      })
      if (success) this.success()
    },
    changeAccess(selectedAppId, accessId) {
      this.currentApp = selectedAppId
      const selected = this.apps[selectedAppId].accesses
      const correct = this.apps[selectedAppId].correctAccesses
      const mayBe = this.apps[selectedAppId].mayBeAccesses
      const index = selected.indexOf(accessId)
      // добавляем/убираем доступ из списка разрешенных для приложения
      if (index > -1) {
        selected.splice(index, 1)
      } else {
        selected.push(accessId)
      }
      // проверяем выбранный доступ на ошибку
      this.checkAccess(accessId, correct, mayBe, selected)
      // проверяем все настроенные доступы к приложению и добавляем/убираем зеленую галочку
      this.checkAllSelectedAccesses(selectedAppId, correct, mayBe, selected)
    },
    checkAccess(accessId, correct, mayBe, selected) {
      // если доступ в списке разрешенных, но не обязательных
      if (mayBe.includes(accessId)) return
      // если выключили доступ, без которого приложение не сможет функционировать
      if (correct.includes(accessId) && !selected.includes(accessId)) {
        this.errorAccessId = accessId
        this.$refs.promptBox.close()
        this.$refs.errorBox.open()
      } else if (!correct.includes(accessId) && selected.includes(accessId)) {
        // если включили лишний доступ
        this.promptAccessId = accessId
        this.$refs.errorBox.close()
        this.$refs.promptBox.open()
      }
    },
    checkAllSelectedAccesses(selectedAppId, correct, mayBe, selected) {
      const wasSuccessStatus = this.apps[selectedAppId].success
      const newSuccessStatus = this.isArrayEquals(selected.sort().filter(el => !mayBe.includes(el)), correct.sort())
      this.apps[selectedAppId].success = newSuccessStatus
      if (wasSuccessStatus !== null && wasSuccessStatus !== undefined && wasSuccessStatus !== newSuccessStatus) {
        const number = newSuccessStatus ? 5 : -5
        this.updateScore(number)
      }
    },
    showInfoBox(id) {
      this.currentApp = id
      setTimeout(() => this.$refs.infoBox.open(), 500)
    },
    updateScore(number) {
      if (number > 0) this.successCount += 1
      else this.successCount -= 1
      this.$store.commit('SET_RESULT', number)
    },
    success() {
      this.stage += 1
      this.$refs.successBox.open()
    },
    init() {
      this.apps = data.map(obj => ({ ...obj, accesses: [...Array(accesses.length).keys()] }))
    },
  },
  created() {
    this.$store.commit('SET_HEX_COLOR', 'purple')
    this.$store.commit('SET_HEX_ROTATION')
  },
  mounted() {
    setTimeout(() => this.$refs.startHelp.open(), 500)
    this.init()
  },
}
</script>
<style lang="scss" module src="./trainer3.scss"></style>
